// extracted by mini-css-extract-plugin
export default {"header-text":"User_header-text__YN+bK","page-main":"User_page-main__-2BvH","table":"User_table__nMM3z"};